// Mock data for Devil Tattooz - bilingual (FR/EN)

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      piercing: 'Piercing',
      bijoux: 'Bijoux',
      grillz: 'Grillz',
      strass: 'Strass dentaire',
      protheseAcier: 'Prothèse acier',
      protheseTitane: 'Prothèse titane',
      realisations: 'Réalisations',
      tattoo: 'Tatouage',
      gallery: 'Galerie',
      reviews: 'Avis',
      contact: 'Contact',
      book: 'Réserver',
    },
    hero: {
      eyebrow: 'Maison de piercing & tatouage — Villiers-sur-Marne',
      title: 'Devil Tattooz',
      subtitle: 'L\u2019art du piercing & du tatouage, sublimé par l\u2019exigence du détail.',
      desc: 'Matériel stérile à usage unique. Prestation sans rendez-vous. Une expérience raffinée, signée par des artisans passionnés.',
      cta1: 'Découvrir nos piercings',
      cta2: 'Réserver une séance',
      walkin: 'Sans rendez-vous',
      sterile: 'Stérile · Usage unique',
      since: 'Depuis 2015',
    },
    about: {
      eyebrow: 'La maison',
      title: 'Une signature française du piercing.',
      p1: 'Au coeur de Villiers-sur-Marne, Devil Tattooz redéfinit l\u2019art du piercing et du tatouage. Notre approche : la précision, l\u2019hygiène irréprochable et l\u2019écoute.',
      p2: 'Chaque bijou est choisi avec soin — Acier chirurgical 316L et Titane G23 — pour sublimer votre singularité avec la délicatesse d\u2019un geste maîtrisé.',
      stat1: 'Années d\u2019expertise',
      stat2: 'Clients satisfaits',
      stat3: 'Note Google',
      stat4: 'Bijoux disponibles',
    },
    services: {
      eyebrow: 'Nos prestations',
      title: 'L\u2019excellence, à fleur de peau.',
      piercingTitle: 'Piercing',
      piercingTag: 'Notre spécialité',
      piercingDesc: 'De l\u2019oreille au microdermal, nos perceurs maîtrisent chaque geste avec une précision d\u2019horloger. Bijoux Acier chirurgical 316L et Titane G23.',
      tattooTitle: 'Tatouage',
      tattooDesc: 'Fine line, minimaliste, ornemental ou réaliste — nos artistes donnent vie à vos idées avec une encre durable et un trait sûr.',
      learnMore: 'En savoir plus',
    },
    piercing: {
      eyebrow: 'Catalogue piercing',
      title: 'Piercings — Tarifs & modèles',
      subtitle: 'Tous nos piercings incluent le bijou en acier chirurgical stérile. Modèles or & titane disponibles en supplément.',
      bookBtn: 'Réserver ce piercing',
      from: 'À partir de',
    },
    tattoo: {
      eyebrow: 'Galerie tatouage',
      title: 'L\u2019encre comme une caresse.',
      subtitle: 'Une sélection de nos réalisations récentes — fine line, lettrage, ornemental et plus.',
      viewAll: 'Voir toute la galerie',
    },
    bijoux: {
      eyebrow: 'Collection bijoux',
      title: 'Bijoux d\u2019exception.',
      subtitle: 'Tous nos bijoux sont en Acier chirurgical 316L et Titane G23 — des matériaux hypoallergéniques de qualité médicale pour une cicatrisation optimale.',
    },
    grillz: {
      eyebrow: 'Collection grillz',
      title: 'Grillz sur mesure.',
      subtitle: 'Bijoux dentaires sur empreinte, conçus à la main en Cobalt Chrome. Une pièce unique pour un sourire qui ne ressemble à aucun autre.',
      priceLabel: 'À partir de',
      priceNote: 'Tarif variable selon le modèle et le nombre de dents.',
      bookBtn: 'Prendre rendez-vous',
    },
    strass: {
      eyebrow: 'Strass dentaire',
      title: 'L\u2019éclat dans le sourire.',
      subtitle: 'Petits cristaux apposés sur la dent — pose indolore, sans perçage, durée 3 à 6 mois. Sublimez votre sourire avec une touche d\u2019éclat.',
      priceLabel: 'À partir de',
      empty: 'Photos bientôt disponibles.',
    },
    realisations: {
      eyebrow: 'Nos réalisations',
      title: 'Piercings réalisés par nous.',
      subtitle: 'Découvrez une sélection de piercings effectués au sein de notre atelier sur de vrais clients.',
      empty: 'Galerie bientôt disponible.',
    },
    protheseAcier: {
      eyebrow: 'Prothèse médicale',
      title: 'Prothèse acier chirurgical.',
      subtitle: 'Prothèses médicales en Acier chirurgical 316L — biocompatibles et hypoallergéniques, conçues pour un confort optimal.',
      empty: 'Modèles bientôt disponibles.',
    },
    protheseTitane: {
      eyebrow: 'Prothèse médicale',
      title: 'Prothèse titane.',
      subtitle: 'Prothèses médicales en Titane G23 — la solution la plus pure et la plus légère pour les peaux les plus sensibles.',
      empty: 'Modèles bientôt disponibles.',
    },
    reviews: {
      eyebrow: 'Avis clients',
      title: 'Ils nous ont fait confiance.',
      rating: 'sur Google',
      total: 'avis vérifiés',
    },
    contact: {
      eyebrow: 'Visitez-nous',
      title: 'L\u2019atelier vous attend.',
      addressLabel: 'Adresse',
      address: '17 Rue Louis Lenoir, 94350 Villiers-sur-Marne, France',
      hoursLabel: 'Horaires',
      followLabel: 'Suivez-nous',
      directions: 'Itinéraire',
      formTitle: 'Réserver votre séance',
      formDesc: 'Laissez-nous un message, nous vous recontactons sous 24h.',
      name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      service: 'Prestation souhaitée',
      message: 'Décrivez votre projet',
      submit: 'Envoyer ma demande',
      success: 'Demande envoyée avec succès. À très vite !',
      days: ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche'],
      closed: 'Fermé',
    },
    footer: {
      tagline: 'Piercing & tatouage — Villiers-sur-Marne',
      quickLinks: 'Liens',
      legal: 'Mentions légales',
      privacy: 'Confidentialité',
      rights: 'Tous droits réservés.',
    },
  },
  en: {
    nav: {
      home: 'Home',
      piercing: 'Piercing',
      bijoux: 'Jewelry',
      grillz: 'Grillz',
      strass: 'Tooth gems',
      protheseAcier: 'Steel prosthesis',
      protheseTitane: 'Titanium prosthesis',
      realisations: 'Our work',
      tattoo: 'Tattoo',
      gallery: 'Gallery',
      reviews: 'Reviews',
      contact: 'Contact',
      book: 'Book',
    },
    hero: {
      eyebrow: 'Piercing & tattoo house — Villiers-sur-Marne',
      title: 'Devil Tattooz',
      subtitle: 'The art of piercing & tattoo, elevated by an obsession with detail.',
      desc: 'Sterile single-use equipment. Walk-ins welcome. A refined experience, signed by passionate artisans.',
      cta1: 'Explore our piercings',
      cta2: 'Book a session',
      walkin: 'Walk-ins welcome',
      sterile: 'Sterile · Single-use',
      since: 'Since 2015',
    },
    about: {
      eyebrow: 'The house',
      title: 'A French signature in piercing.',
      p1: 'In the heart of Villiers-sur-Marne, Devil Tattooz redefines the art of piercing and tattoo. Our approach: precision, impeccable hygiene, and listening.',
      p2: 'Each piece of jewelry is carefully selected — Surgical Steel 316L and Titanium G23 — to enhance your singularity with the delicacy of a mastered gesture.',
      stat1: 'Years of expertise',
      stat2: 'Happy clients',
      stat3: 'Google rating',
      stat4: 'Jewelry pieces',
    },
    services: {
      eyebrow: 'Our services',
      title: 'Excellence, skin deep.',
      piercingTitle: 'Piercing',
      piercingTag: 'Our specialty',
      piercingDesc: 'From ear to microdermal, our piercers master every move with watchmaker precision. Surgical Steel 316L and Titanium G23 jewelry only.',
      tattooTitle: 'Tattoo',
      tattooDesc: 'Fine line, minimalist, ornamental or realistic — our artists bring your ideas to life with lasting ink and a steady hand.',
      learnMore: 'Learn more',
    },
    piercing: {
      eyebrow: 'Piercing catalog',
      title: 'Piercings — Pricing & styles',
      subtitle: 'All piercings include sterile surgical steel jewelry. Gold & titanium models available as an upgrade.',
      bookBtn: 'Book this piercing',
      from: 'From',
    },
    tattoo: {
      eyebrow: 'Tattoo gallery',
      title: 'Ink, like a caress.',
      subtitle: 'A curated selection of our recent work — fine line, lettering, ornamental and more.',
      viewAll: 'View full gallery',
    },
    bijoux: {
      eyebrow: 'Jewelry collection',
      title: 'Exceptional jewelry.',
      subtitle: 'All our jewelry is made of Surgical Steel 316L and Titanium G23 — medical-grade hypoallergenic materials for optimal healing.',
    },
    grillz: {
      eyebrow: 'Grillz collection',
      title: 'Custom grillz.',
      subtitle: 'Custom-fit dental jewelry, handcrafted in Cobalt Chrome from your own impression. A one-of-a-kind piece for a smile that stands out.',
      priceLabel: 'From',
      priceNote: 'Price varies by model and number of teeth.',
      bookBtn: 'Book a session',
    },
    strass: {
      eyebrow: 'Tooth gems',
      title: 'Sparkle in your smile.',
      subtitle: 'Tiny crystals applied to the tooth — painless, no drilling, lasts 3 to 6 months. Elevate your smile with a touch of shine.',
      priceLabel: 'From',
      empty: 'Photos coming soon.',
    },
    realisations: {
      eyebrow: 'Our work',
      title: 'Piercings done by us.',
      subtitle: 'Discover a curated selection of piercings done at our studio on real clients.',
      empty: 'Gallery coming soon.',
    },
    protheseAcier: {
      eyebrow: 'Medical prosthesis',
      title: 'Surgical steel prosthesis.',
      subtitle: 'Medical prostheses in Surgical Steel 316L — biocompatible and hypoallergenic, designed for optimal comfort.',
      empty: 'Models coming soon.',
    },
    protheseTitane: {
      eyebrow: 'Medical prosthesis',
      title: 'Titanium prosthesis.',
      subtitle: 'Medical prostheses in Titanium G23 — the purest and lightest option for the most sensitive skin.',
      empty: 'Models coming soon.',
    },
    reviews: {
      eyebrow: 'Client reviews',
      title: 'They trusted us.',
      rating: 'on Google',
      total: 'verified reviews',
    },
    contact: {
      eyebrow: 'Visit us',
      title: 'The studio is waiting.',
      addressLabel: 'Address',
      address: '17 Rue Louis Lenoir, 94350 Villiers-sur-Marne, France',
      hoursLabel: 'Opening hours',
      followLabel: 'Follow us',
      directions: 'Directions',
      formTitle: 'Book your session',
      formDesc: 'Leave us a message, we will get back to you within 24h.',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      service: 'Desired service',
      message: 'Describe your project',
      submit: 'Send my request',
      success: 'Request sent successfully. See you soon!',
      days: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
      closed: 'Closed',
    },
    footer: {
      tagline: 'Piercing & tattoo — Villiers-sur-Marne',
      quickLinks: 'Links',
      legal: 'Legal',
      privacy: 'Privacy',
      rights: 'All rights reserved.',
    },
  },
};

export const piercingCatalog = [
  { id: 1, nameFr: 'Lobe (oreille)', nameEn: 'Earlobe', price: '15€', extra: '+2€ 2e oreille', img: 'https://images.unsplash.com/photo-1560577938-a5ed9b19fe12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwaWVyY2luZ3xlbnwwfHx8fDE3ODIyMzY5MjZ8MA&ixlib=rb-4.1.0&q=85' },
  { id: 2, nameFr: 'Hélix', nameEn: 'Helix', price: '20€', extra: 'Acier chirurgical', img: 'https://images.pexels.com/photos/30875755/pexels-photo-30875755.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 3, nameFr: 'Tragus', nameEn: 'Tragus', price: '25€', extra: 'Bijou inclus', img: 'https://images.pexels.com/photos/7479508/pexels-photo-7479508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 4, nameFr: 'Septum', nameEn: 'Septum', price: '30€', extra: 'Titane disponible', img: 'https://images.pexels.com/photos/2118710/pexels-photo-2118710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 5, nameFr: 'Narine', nameEn: 'Nostril', price: '25€', extra: 'Bijou inclus', img: 'https://images.pexels.com/photos/37722196/pexels-photo-37722196.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { id: 6, nameFr: 'Microdermal', nameEn: 'Microdermal', price: '20€', extra: '2 pour 35€', img: 'https://images.unsplash.com/photo-1692220527262-094906b793e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwaWVyY2luZ3xlbnwwfHx8fDE3ODIyMzY5MjZ8MA&ixlib=rb-4.1.0&q=85' },
  { id: 7, nameFr: 'Arcade', nameEn: 'Eyebrow', price: '30€', extra: 'Acier chirurgical', img: 'https://images.pexels.com/photos/32275806/pexels-photo-32275806.jpeg' },
  { id: 8, nameFr: 'Labret', nameEn: 'Labret', price: '30€', extra: 'Titane disponible', img: 'https://images.pexels.com/photos/13575093/pexels-photo-13575093.jpeg' },
];

export const tattooGallery = [
  { id: 1, img: 'https://images.pexels.com/photos/32203198/pexels-photo-32203198.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', style: 'Fine line' },
  { id: 2, img: 'https://images.pexels.com/photos/4662164/pexels-photo-4662164.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', style: 'Minimaliste' },
  { id: 3, img: 'https://images.pexels.com/photos/4273458/pexels-photo-4273458.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', style: 'Ornemental' },
  { id: 4, img: 'https://images.pexels.com/photos/7005656/pexels-photo-7005656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', style: 'Studio' },
  { id: 5, img: 'https://images.pexels.com/photos/28991534/pexels-photo-28991534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', style: 'Artiste' },
  { id: 6, img: 'https://images.pexels.com/photos/7479508/pexels-photo-7479508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', style: 'Lettrage' },
];

export const reviewsData = [
  { id: 1, name: 'Sophie L.', rating: 5, dateFr: 'Il y a 2 semaines', dateEn: '2 weeks ago', textFr: 'Accueil au top, perceur très professionnel, geste précis et indolore. Je recommande les yeux fermés !', textEn: 'Amazing welcome, very professional piercer, precise and painless. I highly recommend!' },
  { id: 2, name: 'Karim B.', rating: 5, dateFr: 'Il y a 1 mois', dateEn: '1 month ago', textFr: 'Mon microdermal cicatrise parfaitement. L\u2019hygiène est irréprochable, le salon est élégant.', textEn: 'My microdermal is healing perfectly. The hygiene is impeccable, the salon is elegant.' },
  { id: 3, name: 'Léa M.', rating: 5, dateFr: 'Il y a 3 semaines', dateEn: '3 weeks ago', textFr: 'Tatouage fine line magnifique, le trait est parfait. Bravo à toute l\u2019équipe.', textEn: 'Beautiful fine line tattoo, perfect line work. Bravo to the whole team.' },
  { id: 4, name: 'Antoine R.', rating: 4, dateFr: 'Il y a 2 mois', dateEn: '2 months ago', textFr: 'Très bonne expérience pour mon hélix. Conseils avisés et bijoux de qualité.', textEn: 'Very good experience for my helix. Smart advice and quality jewelry.' },
  { id: 5, name: 'Inès D.', rating: 5, dateFr: 'Il y a 5 jours', dateEn: '5 days ago', textFr: 'L\u2019adresse de référence à Villiers. Cadre raffiné et travail soigné.', textEn: 'The reference address in Villiers. Refined setting and meticulous work.' },
];

export const hours = [
  { day: 0, openFr: 'Fermé', openEn: 'Closed', closed: true },
  { day: 1, openFr: '10h00 – 20h00', openEn: '10 AM – 8 PM', closed: false },
  { day: 2, openFr: '10h00 – 20h00', openEn: '10 AM – 8 PM', closed: false },
  { day: 3, openFr: '10h00 – 20h00', openEn: '10 AM – 8 PM', closed: false },
  { day: 4, openFr: '10h00 – 20h00', openEn: '10 AM – 8 PM', closed: false },
  { day: 5, openFr: '10h00 – 20h00', openEn: '10 AM – 8 PM', closed: false },
  { day: 6, openFr: '11h00 – 19h30', openEn: '11 AM – 7:30 PM', closed: false },
];

export const socials = {
  instagram: 'https://www.instagram.com/devil_perceur/',
  tiktok: 'https://www.tiktok.com/@devil_tattooz',
  youtube: 'https://www.youtube.com/channel/UCo801Ush12JAVLwSRFzu4UA',
};
